import React, { Fragment } from "react";
import PropTypes from "prop-types";
import IconButton from "@mui/material/IconButton";
import ForwardIcon from "@mui/icons-material/ArrowForward";
import BackIcon from "@mui/icons-material/ArrowBack";

const Pagination = ({ nextPage, prevPage, items, page }) => {
  return (
    <Fragment>
      <IconButton onClick={prevPage} disabled={page <= 1}>
        <BackIcon />
      </IconButton>
      <IconButton onClick={nextPage} disabled={items.length === 0}>
        <ForwardIcon />
      </IconButton>
    </Fragment>
  );
};

Pagination.propTypes = {
  page: PropTypes.number.isRequired,
  nextPage: PropTypes.func.isRequired,
  prevPage: PropTypes.func.isRequired,
  items: PropTypes.array.isRequired,
};

export default Pagination;
